module.exports = __webpack_public_path__ + "static/media/N4.162f5c09.png";